import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import OurCare from "@/pages/our-care/page";
import LifeHere from "@/pages/life-here/page";
import Visit from "@/pages/visit/page";
import SiteLayout from "@/components/feature/SiteLayout";

const routes: RouteObject[] = [
  {
    element: <SiteLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/our-care", element: <OurCare /> },
      { path: "/life-here", element: <LifeHere /> },
      { path: "/visit", element: <Visit /> },
    ],
  },
  { path: "*", element: <NotFound /> },
];

export default routes;